const ListIcon = ({
  fill = '#000000',
  height = 24,
  width = 24,
  fillOpacity = '0.54',
}: {
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string;
}): React.ReactElement => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='1.33325'
      y='4.66667'
      width='21.3333'
      height='4'
      rx='2'
      fill={fill}
      fillOpacity={fillOpacity}
    />
    <rect
      x='1.33325'
      y='10'
      width='6.66667'
      height='4'
      rx='2'
      fill={fill}
      fillOpacity={fillOpacity}
    />
    <rect
      x='1.33325'
      y='15.3333'
      width='6.66667'
      height='4'
      rx='2'
      fill={fill}
      fillOpacity={fillOpacity}
    />
    <rect
      x='9.33325'
      y='10'
      width='13.3333'
      height='4'
      rx='2'
      fill={fill}
      fillOpacity={fillOpacity}
    />
    <rect
      x='9.33325'
      y='15.3333'
      width='13.3333'
      height='4'
      rx='2'
      fill={fill}
      fillOpacity={fillOpacity}
    />
  </svg>
);

export default ListIcon;
